/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const it_search_preview_content_courses_title = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Master e corsi (${i.count})`
};

const en_search_preview_content_courses_title = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Courses (${i.count})`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "it" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_preview_content_courses_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_preview_content_courses_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_preview_content_courses_title", locale)
	if (locale === "it") return it_search_preview_content_courses_title(inputs)
	return en_search_preview_content_courses_title(inputs)
};
export { search_preview_content_courses_title as "search-preview-content.courses-title" }